var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"image-button",style:(_vm.dynamicBackground),on:{"click":function($event){return _vm.$emit('click', _vm.action)}}})}
var staticRenderFns = []

export { render, staticRenderFns }